import { format } from "date-fns";
export const dateConvertItem = (date) => {
  if (date) {
    const datetime = new Date(date);

    return format(datetime, "dd-MM-yyyy");
  }
};


export const dateConvertMonth = (date) => {
  if (date) {
    const datetime = new Date(date);

    return format(datetime, "MM-dd-yyyy");
  }
};


export const dateConvertFull = (date) => {
  if (date) {
    const datetime = new Date(date);

    return format(datetime, "dd-MM-yyyy hh:mm aa", { useAdditionalDayOfYearTokens: true });
  }
};
